import {route} from 'react-router-typesafe-routes';

export const profileRoutesPath = route({
  children: {
    certification: route({
      path: 'certification',
    }),
    info: route({
      path: 'info',
    }),
    settings: route({
      path: 'settings',
    }),
    subscription: route({
      path: 'user-payments',
    }),
  },
  path: 'profile',
});
